import fetchReducer from "./fetchApiData/reducer";
import postReducer from "./postApiData/reducer";

const rootReducer = {
  fetch: fetchReducer,
  post: postReducer,
};

export default rootReducer;
